module.exports = __webpack_public_path__ + "img/nhl21.67f47d23.png";